import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { RadiantSpinner } from 'components/RadiantSpinner'

import { PinnedNote } from 'modules/unsubscribe/components/PinnedNote'
import { useCanceledPlan } from 'modules/unsubscribe/pages/CanceledPlan/useCanceledPlan'

import { FlowButton } from '../../components/FlowButton'
import { FlowPageContainer } from '../../components/FlowPageContainer'
import { useRetentionFlowV2Config } from '../../hooks/useRetentionFlowV2Config'
import { FlowBottomArea, FlowContent, FlowOutcomeTitle } from '../../styles'

export const FlowCanceledPlan: React.FC = () => {
  const { t } = useTranslation()
  const { copyKey } = useRetentionFlowV2Config()
  const { isInProgress, goToAccountPage } = useCanceledPlan()

  return (
    <FlowPageContainer>
      {isInProgress ? (
        <FlowContent>
          <FlowOutcomeTitle>
            {t('retention.canceledPlan.step1Title')}
          </FlowOutcomeTitle>
          <RadiantSpinner />
        </FlowContent>
      ) : (
        <>
          <FlowContent>
            <FlowOutcomeTitle>
              {t('retention.canceledPlan.step2Title')}
            </FlowOutcomeTitle>
            <PinnedNote>
              <Trans
                i18nKey={`${copyKey}.canceledPlan.note`}
                components={{ br: <br /> }}
              />
            </PinnedNote>
          </FlowContent>
          <FlowBottomArea isFixed>
            <FlowButton type="button" onClick={goToAccountPage}>
              {t(`${copyKey}.canceledPlan.okButton`)}
            </FlowButton>
          </FlowBottomArea>
        </>
      )}
    </FlowPageContainer>
  )
}
